import {memo} from "react";
import {Pie} from '@ant-design/charts';

const UniversityChart = memo(({data, customConfig = {}}) => {

    var config = {
        appendPadding: 10,
        data: data,
        angleField: 'percentage',
        colorField: 'university',
        radius: 0.9,
        meta: {
            percentage: {
                alias: 'เปอร์เซ็นต์',
                formatter: (v) => `${v.toFixed(2)}%`
            }
        },
        label: {
            type: 'outer',
            content: (_ref) => `${_ref.university} ${_ref.percentage.toFixed(2)}%`,
        },
        interactions: [{ type: 'element-active' }],
    };
    return <Pie {...config} />;
})

export default UniversityChart;